export const generateKeywordsProps = (t: any) => {
	return {
		className: 'react-tagsinput-input w-100',
		placeholder: t('add_keyword'),
		id: 'content-seo-keywords-input',
	};
};
